import React, {Component} from 'react'
import {Card, Container, Button, Collapse, TabPane } from 'react-bootstrap'
import { withTranslation } from "react-i18next";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {connect} from "react-redux";
import {GET_TASKS_BY_ID} from "../../sagas/tasks/types";
import {STAGE} from "../../config/constants/states";

const {
  EMPTY_STATE,
  INCOMPLETE_STATE,
  ACTUAL,
  COMPLETE_STATE,
} = STAGE;

function CollapseTask(props) {
  const { t } = props;
  const Tasks = props.tasks.map(task => {
    return (
        <div key={props.id} className="text-stage">
          <Button variant="link" className="h6" onClick={e => props.handleGetTask(task)}>{t(task.name)}</Button>
        </div>
    )
  });
  return (
    <Collapse
      name={props.stage.name}
      id={`collapse_${props.stage.number}`}
      aria-labelledby="headingTwo"
      data-parent="#accordionExample"
      {...(props.state === 3) && {className: 'show'}}>
      <Card.Body>
        <div className="card-body">
        {Tasks}
        </div>
      </Card.Body>
    </Collapse>
  )
}

class StageCollapse extends Component {
  render() {
    const { t } = this.props;
    return (
    <>
      {
        this.props.stages.map((stage, i) => (
          <>
            <div className="ic-stage">
              <Button variant="secondary"
                      data-toggle="collapse"
                      data-target={`#collapse_${stage.number}`}
                      aria-controls={`collapse_${stage.number}`}>
                {
                  (stage.state === COMPLETE_STATE) ? <FontAwesomeIcon
                      className="fa-lg active float-left align-middle"
                      icon="check-circle"/> :
                    (stage.state === INCOMPLETE_STATE || stage.state === ACTUAL) ?
                      <div className="circle-process float-left text-center">{(stage.number + 1)}</div> :
                      <div className="circle-process circle-np float-left text-center">{(stage.number + 1)}</div>
                }


                <div className={`text-stage ml-3 float-left  ${(stage.state === ACTUAL)
                  ? 'd-inline-block' : (stage.state === EMPTY_STATE)
                    ? 'd-inline-block inactive' : ''}`}>
                  <h6 className={(stage.state === COMPLETE_STATE)
                    ? 'success font-weight-bold mb-0 mt-1' : 'mb-0 mt-1'}>{t(stage.name)}</h6>
                </div>


                <FontAwesomeIcon className="fan dark-color float-right mt-1"
                                 icon={`chevron-${(stage.state === ACTUAL) ? 'up' : 'down'}`}/>


              </Button>
            </div>
            <CollapseTask t={t} handleGetTask={task => this.props.getTask(task)} key={stage.id} tasks={stage.tasks}
                          stage={stage} state={stage.state} index={i} length={this.props.stages.length}/>
          </>
        ))
      }
    </>
  )}
}

class SideBar extends Component {
  handleGetTask(task) {
    const {id} = task;
    this.props.getTask(id);
  }

  render() {
    const { t } = this.props;
    return (
      <TabPane active className="show mt-4" id="stages" role="tabpanel" aria-labelledby="stages-tab">
        <div className="accordion" id="accordionExample">
          <Container id="headingOne">
            <div className="line">
              <StageCollapse
                t={t}
                key="stage-collapse"
                getTask={task => this.handleGetTask(task)}
                stages={this.props.stages}/>
            </div>
          </Container>
        </div>
      </TabPane>
    )
  }
}

const data = state => ({
  cause: state.cause.cause,
  task: state.task.task,
  stages: state.cause.cause.hasOwnProperty('stages')
    ? state.cause.cause.stages
    : []
});

const actions = dispatch => ({
  getTask: (id) => dispatch({type: GET_TASKS_BY_ID, payload: id})
});
export default connect(data, actions)(withTranslation()(SideBar))
